// extracted by mini-css-extract-plugin
module.exports = {"monthInfoBodyWrapper":"_vNtb","monthInfoSelectWrapper":"ud6ow","monthInfoSelect":"_3dQgz","replaceActivityAlert":"_280vH","replaceActivityAlertIcon":"_1thkM"};